import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const FeedbackCard = ({ feedback, onViewDetails, onContactClient, onUpdateProject }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'approved':
        return 'text-success bg-success/10';
      case 'rejected':
        return 'text-error bg-error/10';
      case 'pending':
        return 'text-warning bg-warning/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'approved':
        return 'CheckCircle';
      case 'rejected':
        return 'XCircle';
      case 'pending':
        return 'Clock';
      default:
        return 'Circle';
    }
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })?.format(new Date(date));
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 elevation-1 hover:elevation-2 transition-luxury">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-heading text-foreground mb-1">{feedback?.projectName}</h3>
          <p className="text-sm text-muted-foreground">{feedback?.clientName} • {feedback?.clientEmail}</p>
        </div>
        <div className={`flex items-center space-x-2 px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(feedback?.status)}`}>
          <Icon name={getStatusIcon(feedback?.status)} size={14} />
          <span className="capitalize">{feedback?.status}</span>
        </div>
      </div>
      {feedback?.feedbackNote && (
        <div className="mb-4 p-4 bg-muted rounded-lg">
          <p className="text-sm text-foreground leading-relaxed">{feedback?.feedbackNote}</p>
        </div>
      )}
      <div className="flex items-center justify-between text-xs text-muted-foreground mb-4">
        <span>Submitted {formatDate(feedback?.submittedAt)}</span>
        {feedback?.viewedAt && (
          <span>Viewed {formatDate(feedback?.viewedAt)}</span>
        )}
      </div>
      <div className="flex items-center space-x-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Eye"
          iconPosition="left"
          onClick={() => onViewDetails(feedback?.id)}
        >
          View Details
        </Button>
        <Button
          variant="ghost"
          size="sm"
          iconName="MessageCircle"
          iconPosition="left"
          onClick={() => onContactClient(feedback?.clientEmail)}
        >
          Contact
        </Button>
        {feedback?.status === 'rejected' && (
          <Button
            variant="ghost"
            size="sm"
            iconName="RefreshCw"
            iconPosition="left"
            onClick={() => onUpdateProject(feedback?.projectId)}
          >
            Update
          </Button>
        )}
      </div>
    </div>
  );
};

export default FeedbackCard;